import axios from 'axios'

const state = {
    search: [],
    nb: 0,
    filtres: [],
    recherche: '',
    onlyNews: false,
    prixMin: 0,
    prixMax: 1000000,
    firstPrixMin: 0,
    firstPrixMax: 0,
    tailles: [{
            Libelle: "18x12",
            selected: false
        },
        {
            Libelle: "20x15",
            selected: false
        },
        {
            Libelle: "25x18",
            selected: false
        },
        {
            Libelle: "30x20",
            selected: false
        },
        {
            Libelle: "35x25",
            selected: false
        },
        {
            Libelle: "40x30",
            selected: false
        },
        {
            Libelle: "50x40",
            selected: false
        },
        {
            Libelle: "45x35",
            selected: false
        },
        {
            Libelle: "Autres",
            selected: false
        }
    ],
    geometries: [{
            Libelle: "Rectangle",
            selected: false
        },
        {
            Libelle: "Bords éclatés",
            selected: false
        },
        {
            Libelle: "Forme",
            selected: false
        },
        {
            Libelle: "Jet d'eau",
            selected: false
        },
        {
            Libelle: "Coeur",
            selected: false
        },
        {
            Libelle: "Livre",
            selected: false
        },
        {
            Libelle: "Ovale",
            selected: false
        },
        {
            Libelle: "Croix",
            selected: false
        },
        {
            Libelle: "Autres",
            selected: false
        }
    ],
    materiaux: [{
            Libelle: "Résine",
            selected: false
        },
        {
            Libelle: "Altu",
            selected: false
        },
        {
            Libelle: "Altu marbré",
            selected: false
        },
        {
            Libelle: "Altu photo",
            selected: false
        },
        {
            Libelle: "Céramique",
            selected: false
        },
        {
            Libelle: "Céramique fine",
            selected: false
        },
        {
            Libelle: "Verre",
            selected: false
        }
    ],
    bEtMs: [{
            Libelle: "Bronze",
            selected: false
        },
        {
            Libelle: "Patiné",
            selected: false
        },
        {
            Libelle: "Motif",
            selected: false
        },
        {
            Libelle: "Plaque à graver",
            selected: false
        }
    ],
    searchLoading: false,
    familleArticles: [],
    lastPromise: null
}

const getters = {
    search: state => state.search,
    recherche: state => state.recherche,
    onlyNews: stae => state.onlyNews,
    nb: state => state.nb,
    filtres: state => state.filtres,
    tailles: state => state.tailles,
    geometries: state => state.geometries,
    materiaux: state => state.materiaux,
    bEtMs: state => state.bEtMs,
    prixMin: state => state.prixMin,
    prixMax: state => state.prixMax,
    firstPrixMin: state => state.firstPrixMin,
    firstPrixMax: state => state.firstPrixMax,
    searchLoading: state => state.searchLoading,
    familleArticles: state => state.familleArticles
}


const actions = {
    /**
     * Service pour executer une recherche sur des articles d'une famille.
     * @param {*} param0
     * @param {*} param
     */
    getSearch({
        commit
    }, param) {
        commit('setSearchLoading', true);
        const promise = fetch( '/message/' + 1 );
        commit( 'setLastPromise', promise );
        return new Promise((resolve, reject) => {
            axios.get('/api/search', {
                params: {
                    page: param.page,
                    famille: param.famille,
                    filtres: state.filtres,
                    prixMin: param.prixMin,
                    prixMax: param.prixMax,
                    onlyNouveaute: param.onlyNouveaute,
                    sort: param.sort,
                    recherche: param.recherche,
                    firstSearch: param.firstSearch,
                }
            }).then(response => {
              if ( promise == state.lastPromise ) {
                commit('setSearch', response.data)
                commit('setPrixMin', eval(response.data[1]).toFixed(2))
                commit('setPrixMax', eval(response.data[2]).toFixed(2))
                if (eval(response.data[3]).toFixed(2) > 0) {
                  commit('setFirstPrixMin', eval(response.data[3]).toFixed(2))
                  commit('setFirstPrixMax', eval(response.data[4]).toFixed(2))
                }
                commit('setSearchLoading', false)
                resolve(response.data);
              }
            }).catch(error => {
                commit('setSearchLoading', false)
                reject(error);
            });
        });
    },

    /**
     * Service pour récupérer les familles articles.
     * @param {*} param0
     */
    getFamilleArticles({
        commit
    }) {
        return new Promise((resolve, reject) => {
            axios.get('/api/familleArticles').then(response => {
                commit('setFamilleArticles', response.data)
                resolve(response.data)
            }).catch(err => {
                console.log(err)
                reject(err)
            })
        })
    }
}

const mutations = {
    setLastPromise( state, value ) {
      state.lastPromise = value;
    },

    setSearch(state, search) {
        if (search[0].data[0] && state.search.findIndex((s) => s.Code == search[0].data[0].Code) < 0) {
            state.search = [...state.search, ...search[0].data];
        }
        state.nb = search[0].total
    },
    setRecherche(state, recherche) {
        state.recherche = recherche
    },
    setOnlyNews(state, onlyNews) {
        state.onlyNews = onlyNews
    },
    setPrixMin(state, prixMin) {
        state.prixMin = prixMin
    },
    setPrixMax(state, prixMax) {
        state.prixMax = prixMax
    },
    setFirstPrixMin(state, prixMin) {
        state.firstPrixMin = Math.round(prixMin)
    },
    setFirstPrixMax(state, prixMax) {
        state.firstPrixMax = Math.round(prixMax)
    },
    setSearchLoading(state, searchLoading) {
        state.searchLoading = searchLoading
    },
    setFamilleArticles(state, familleArticles) {
        state.familleArticles = familleArticles
    },
    resetFiltres(state) {
        state.filtres = []
        state.prixMin = 0
        state.prixMax = 1000000
        state.onlyNews = false
        state.recherche = ''
        state.tailles.forEach(aTaille => {
            aTaille.selected = false
        });
        state.geometries.forEach(aTaille => {
            aTaille.selected = false
        });
        state.bEtMs.forEach(aTaille => {
            aTaille.selected = false
        });
        state.materiaux.forEach(aTaille => {
            aTaille.selected = false
        });
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
